import { useCallback, useState } from 'react';

interface UseCSVModalOptions {
  onImportComplete?: () => void;
}

interface UseCSVModalReturn {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  handleImportComplete: () => void;
}

export function useCSVModal(options: UseCSVModalOptions = {}): UseCSVModalReturn {
  const { onImportComplete } = options;
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleImportComplete = useCallback(() => {
    if (onImportComplete) {
      onImportComplete();
    }
  }, [onImportComplete]);

  return {
    isOpen,
    open,
    close,
    handleImportComplete,
  };
}
